export function register() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      const url = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
      navigator.serviceWorker.register(url).catch(() => {});
    });
  }
}
